<template>
  <div class="container">
    <div class="register content">
      <steps class="steps" step="one" />

      <h1>{{ $t("register.title") }}</h1>
      <p class="text-center">{{ $t("register.subtitle") }}</p>
      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 position-relative">
          <v-card-text>
            <v-form>
              <v-text-field
                name="name"
                :label="$t('register.name')"
                v-model="name"
                type="text"
              ></v-text-field>
              <v-text-field
                name="email"
                :label="$t('register.email')"
                v-model="email"
                type="text"
              ></v-text-field>
              <span v-if="email_exist" class="error">{{
                $t("register.account_exists")
              }}</span>
              <v-text-field
                id="password"
                name="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                :label="$t('register.password')"
                v-model="password"
              ></v-text-field>
              <v-text-field
                id="confirm-password"
                name="confirm-"
                :label="$t('register.confirm_password')"
                v-model="confirmPassword"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
              ></v-text-field>
              <template v-if="bad_password">
                <span class="error" v-if="password !== null">{{
                  $t("register.password_not_match")
                }}</span>
                <span class="error 3" v-else>{{
                  $t("register.password_missing")
                }}</span>
              </template>
            </v-form>
          </v-card-text>

          <button
            class="login-button btn btn-danger"
            v-bind:disabled="disabled"
            @click="login"
          >
            <template v-if="!disabled">{{ $t("login.continue") }}</template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Steps from "../../components/icons/steps.vue";
import { OrizonApiClient } from "../../services/OrizonApiClient";

import { UserStore } from "@/stores/userStore";
import { i18n } from "@/functional/languages";
import MetaService from "@/services/MetaService";
import { mapState } from "pinia";
import { SessionStore } from "@/stores/sessionStore";
const userStore = UserStore();
import clevertap from "@/services/Clevertap";

const apiClient = new OrizonApiClient();
export default {
  name: "RegisterView",
  metaInfo: () => {
    return {
      title: i18n.global.t("home.meta.title"),
      htmlAttrs: { lang: i18n.global.locale },
      meta: [
        MetaService.robotIndex(),
        MetaService.description(i18n.global.t("home.meta.description")),
      ],
    };
  },
  components: { Steps },
  data() {
    return {
      show1: false,
      disabled: false,
      bad_password: false,
      email_exist: false,
      email: null,
      name: null,
      password: null,
      confirmPassword: null,
    };
  },
  beforeMount() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
  mounted() {
    this.$meta.canonicalUrls(
      this.$t("routes.register", "es"),
      this.$t("routes.register", "en")
    );
  },
  computed: {
    freemiumWorkflow() {
      return SessionStore().freemiumWorkflow;
    },
  },
  methods: {
    login() {
      this.disabled = true;
      console.info(
        this.password,
        this.password !== null,
        this.confirmPassword !== null,
        this.password === this.confirmPassword
      );
      if (
        this.password !== null &&
        this.confirmPassword !== null &&
        this.password !== "" &&
        this.confirmPassword !== "" &&
        this.password === this.confirmPassword
      ) {
        this.bad_password = false;
      } else {
        this.bad_password = true;
        this.disabled = false;
        return;
      }
      apiClient.validateEmail(this.email).then((response) => {
        if (!response.data.error) {
          if (response.data.status === false) {
            let flMark = userStore.getFlMark;
            apiClient
              .registerUser(this.email, this.password, this.name, flMark)
              .then((response) => {
                if (!response.data.error) {
                  console.info(response.data);

                  userStore.setToken(response.data.token);
                  userStore.setAccount(response.data);
                  window.dataLayer.push({
                    event: "account_created",
                  });
                  if (SessionStore().freemiumWorkflow === true) {
                    clevertap.onUserLogin.push({
                      Site: {
                        Identity: userStore.userAccount["user_id"], // String or number
                        Email: userStore.userAccount["email"], // Email address of the user
                      },
                    });
                    clevertap.event.push("Activated Free Plan", {
                      Platform: "Web",
                    });
                    window.dataLayer.push({
                      event: "free_plan_activated",
                    });
                    this.$router.push({
                      name: "live",
                    });
                  } else {
                    this.$router.push({
                      name: "plans-logged",
                    });
                  }
                }
              });
          } else {
            this.email_exist = true;
          }
        }
        this.disabled = false;
      });
      // this.$router.push({name: 'login'})
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.register {
  min-height: 80vh;
  height: auto;
  input:-webkit-autofill,
  input:-webkit-autofill:visited,
  input:-webkit-autofill:focus-within,
  input:-webkit-autofill:focus-visible,
  input:-webkit-autofill:target,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }

  button {
    &:disabled {
      &:before {
        content: ".";
        color: $red;
      }
      background-image: url("@/assets/img/loading.gif");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      cursor: wait;
    }
  }

  .error {
    position: relative;
    top: -1.5em;
    color: $red;
  }
  p {
    font-size: 1.25rem;
  }
  .steps {
    margin: 4em auto 0;
    display: block;
    max-width: 100%;
  }
  h1 {
    font-size: 4.25rem;
    line-height: 5.25rem;
    text-align: center;
    padding: 0.3em 0 0.3em;
    margin: 0;
  }
  .btn {
    padding: 0.7em 2em;
    &.login-button {
      width: 75%;
      margin: 2em auto;
      display: block;
    }
  }
  .v-text-field {
    position: relative;

    .v-input__append {
      position: absolute;
      right: 1em;
      top: 1em;

      .mdi-eye {
        background: url("@/assets/img/eye.png") no-repeat center center;
        background-size: contain;
        opacity: 1 !important;
      }
    }
  }
  @media (max-width: 600px) {
    h1 {
      font-size: 2em;
    }
    .btn {
      &.login-button {
        width: 100%;
      }
    }
  }
}
</style>
